import { Component, Input } from '@angular/core';
import { ITransicaoPossivel } from './workflow-status-popover.interface';

@Component({
  selector: 'workflow-status-popover',
  templateUrl: './workflow-status-popover.component.html',
  styleUrls: ['./workflow-status-popover.component.scss'],
})
export class WorkflowStatusPopoverComponent {
  @Input() statusData!: ITransicaoPossivel[];
  @Input() onSelectStatus!: (status: any) => void;

  handleSelect(status: any) {
    if (this.onSelectStatus) {
      this.onSelectStatus(status);
    }
  }
}
